/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_RolesInputs */

const cs_col_roles = /** @type {(inputs: Col_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const en_col_roles = /** @type {(inputs: Col_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

/**
* | output |
* | --- |
* | "Roles" |
*
* @param {Col_RolesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_roles = /** @type {((inputs?: Col_RolesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_RolesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_roles(inputs)
	return cs_col_roles(inputs)
});